const CapitalizeSvg = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
      <path
        d="M1.125 11L4.0967 3L7.0684 11M6.0283 8.2H2.16509M9.31132 6.6C9.6132 5.88275 10.3267 5.4 11.1439 5.4C12.283 5.4 13.125 6.2 13.125 7.4V11"
        stroke="#252A34"
        strokeWidth="1.1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.125 9.56198C9.125 10.4545 9.7965 11 10.625 11C11.975 11 13.125 10.3306 13.125 8.3719V8C12.625 8 11.675 8.02479 10.825 8.12397C10.0058 8.21967 9.125 8.59504 9.125 9.56198Z"
        stroke="#252A34"
        strokeWidth="1.1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CapitalizeSvg;
